import { render, staticRenderFns } from "./MbNoticeWidget.vue?vue&type=template&id=3fd684d3&"
import script from "./MbNoticeWidget.vue?vue&type=script&lang=js&"
export * from "./MbNoticeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports